import { fetchUserDashboardSummary } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const UserDashboardSummaryKeys = {
    all: ['user-dashboard-summary'] as const,
}

export const useUserDashboardSummaryQuery = () => {
    return useQuery({
        queryFn: fetchUserDashboardSummary,
        queryKey: UserDashboardSummaryKeys.all,
    })
}
